const sessionsMessages = {
    addAnnotationPlaceholder: {
        defaultMessage: 'Add an ad-hoc annotation...',
        id: 'custom_annotation.addPlaceholder',
    },
    addAnnotationTooltip: {
        defaultMessage: 'Add annotation',
        id: 'custom_annotation.tooltip',
    },
    addCustomAnnotation: {
        defaultMessage: 'Add as an ad-hoc annotation',
        id: 'sessions.annotations.addCustomAnnotation',
    },
    addOrSearchAnnotationPlaceholder: {
        defaultMessage: 'Type to create new annotation or search for predefined annotation',
        id: 'custom_annotation.addOrSearchPlaceholder',
    },
    addSimData: {
        defaultMessage: 'Upload Simulator Data',
        id: 'sessions.uploadSimulatorData',
    },
    addToLibrary: {
        defaultMessage: 'Add annotations to annotation library',
        id: 'sessions.annotations.addToLibrary',
    },
    annotationAdded: {
        defaultMessage: 'Annotation Added: {text}',
        id: 'sessions.annotationAdded',
    },
    annotationLabel: {
        defaultMessage: '{timestamp} by {annotator}',
        description: 'timestamp by annotator',
        id: 'sidebar_event_log.annotation_label',
    },
    annotations: {
        defaultMessage: 'Annotate',
        id: 'sidebar_annotations.header',
    },
    annotationsLocked: {
        defaultMessage: 'Annotations have been locked for this session.',
        id: 'sessions.delete_session.annotations_locked',
    },
    associateAnnotations: {
        defaultMessage: 'Add annotations to scenario',
        id: 'sessions.annotations.associateAnnotations',
    },
    bulkDeleteConfirmation: {
        defaultMessage: 'Are you sure you want to delete these {count} sessions? This action is not reversible.',
        id: 'session_list.bulk_delete.confirmation',
    },
    bulkDeleteItemsToDelete: {
        defaultMessage: '{count} {count, plural, one {session} other {sessions}} will be deleted.',
        id: 'session_list.bulk_delete.items_to_delete',
    },
    bulkDeleteModalTitle: {
        defaultMessage: 'Bulk Delete',
        id: 'session_list.bulk_delete.title',
    },
    bulkHelpText: {
        defaultMessage: 'To edit an attribute, click the corresponding checkbox to enable.',
        description: 'Bulk Update Sessions helptext',
        id: 'sessions.bulk.helpText',
    },
    bulkLocationError: {
        defaultMessage: 'Please select a valid location.',
        id: 'sessions.bulk.location.error',
    },
    bulkLocationHelp: {
        defaultMessage: 'To which location do these sessions belong?',
        id: 'sessions.bulk.location.helpText',
    },
    bulkNotesHelp: {
        defaultMessage: "Adding text here will append to the each session's existing notes.",
        id: 'sessions.bulk.notes.helpText',
    },
    bulkOrganizationError: {
        defaultMessage: 'Please select a valid organization.',
        id: 'sessions.bulk.organization.error',
    },
    bulkOrganizationHelp: {
        defaultMessage: 'To which organization do these sessions belong?',
        id: 'sessions.bulk.organization.helpText',
    },
    bulkOwnerError: {
        defaultMessage: 'Please select a valid owner.',
        id: 'sessions.bulk.owner.error',
    },
    bulkOwnerHelp: {
        defaultMessage: 'To which user do these sessions belong?',
        id: 'sessions.bulk.owner.helpText',
    },
    bulkSharingMultipleUsersHelpText: {
        defaultMessage: 'Users selected here will be added to the selected sessions. No users will be removed.',
        id: 'sessions.bulk_update.multiple_users.help_text',
    },
    bulkUpdatePodTitle: {
        defaultMessage: 'Bulk update ({numSessions} sessions)',
        id: 'sessions.bulk_update.pod_title',
    },
    changePermissions: {
        defaultMessage: 'Change Permissions',
        id: 'sessions.people.change_permissions',
    },
    clearSearch: {
        defaultMessage: 'Clear Search',
        id: 'sessions.annotations.clearSearch',
    },
    completedEvaluationTitle: {
        defaultMessage: '{evaluator} evaluated {evaluatee}',
        id: 'sidebar_evaluations.complete_title',
    },
    completedEvaluationTitleTeam: {
        defaultMessage: '{evaluator} evaluated the Team',
        id: 'sidebar_evaluations.complete_title_team',
    },
    completedEvaluations: {
        defaultMessage: 'Completed Evaluations',
        id: 'sidebar_evaluations.complete',
    },
    completedReflectionTitle: {
        defaultMessage: '{evaluator} Reflection',
        id: 'sidebar_evaluations.complete_reflection_title',
    },
    connectionQualityExcellent: {
        defaultMessage: 'Connection quality: excellent',
        id: 'sessions.connection_quality.excellent',
    },
    connectionQualityFair: {
        defaultMessage: 'Connection quality: fair',
        id: 'sessions.connection_quality.fair',
    },
    connectionQualityGood: {
        defaultMessage: 'Connection quality: good',
        id: 'sessions.connection_quality.good',
    },
    connectionQualityLost: {
        defaultMessage: 'Connection quality: lost',
        id: 'sessions.connection_quality.lost',
    },
    connectionQualityPoor: {
        defaultMessage: 'Connection quality: poor',
        id: 'sessions.connection_quality.poor',
    },
    confirmDeleteEvaluation: {
        defaultMessage: 'Confirm Delete',
        id: 'sidebar_evaluations.confirmDelete',
    },
    conflictingParticipantsModalDescriptionPlural: {
        defaultMessage:
            'The following users cannot be session participants because they are already course administrators:',
        id: 'sessions.people.conflicting_participants.modal.description.plural',
    },
    conflictingParticipantsModalDescriptionSingle: {
        defaultMessage:
            'The following user cannot be a session participant because they are already a course administrator:',
        id: 'sessions.people.conflicting_participants.modal.description.single',
    },
    conflictingParticipantsModalTitle: {
        defaultMessage: 'Cannot Assign Participants',
        id: 'sessions.people.conflicting_participants.modal.title',
    },
    contributorPlaceholder: {
        defaultMessage: 'Search for a contributor',
        id: 'contributor_input.placeholder',
    },
    contributorsPermissions: {
        defaultMessage: 'Contributor Permissions',
        id: 'sessions.people.contributors_permissions',
    },
    contributorsPermissionsInfoText: {
        defaultMessage:
            'Contributors can view the session and see all annotations. If given permission, they may also have access to edit, annotate and view completed reflections.',
        id: 'sessions.people.contributors_permissions.info_text',
    },
    courseOwnersAndContributors: {
        defaultMessage: 'Course Owner and Contributors',
        description: 'label for course owner field',
        id: 'sessions.people.course_owner_and_contributors',
    },
    courseOwnersAndContributorsHelp: {
        defaultMessage:
            'Course Owner and Contributors are inherited from the selected Course. They can view, edit, and annotate sessions but cannot delete the session or change the session owner.',
        description: 'help text to say why the contributor cannot be changed',
        id: 'sessions.people.course_owner_and_contributors_help',
    },
    createExternalLink: {
        defaultMessage: 'Create External Link',
        id: 'session.external_link.create',
    },
    deleteSession: {
        defaultMessage: 'Delete entire session',
        id: 'sessions.delete_session_modal.session',
    },
    deleteSessionModalConfirmation: {
        defaultMessage: 'Are you sure you want to delete this session?',
        id: 'sessions.delete_session_modal.confirmation',
    },
    deleteSessionModalTitle: {
        defaultMessage: 'Delete Session',
        id: 'sessions.delete_session_modal.title',
    },
    deleteSimulatorData: {
        defaultMessage: 'Delete simulator data',
        id: 'sessions.delete_session_modal.simulator_data',
    },
    deleteTranscripts: {
        defaultMessage: 'Delete transcripts',
        id: 'sessions.delete_session_modal.transcripts',
    },
    deleteVideos: {
        defaultMessage: 'Delete videos',
        id: 'sessions.delete_session_modal.videos',
    },
    downloadFileName: {
        defaultMessage: '{sessionTitle} - video {videoCount}',
        id: 'sessions.summary.download_videos.file_name',
    },
    downloadFileTitle: {
        defaultMessage: 'Video {videoCount}',
        id: 'sessions.summary.download_videos.file_title',
    },
    downloadInstructions: {
        defaultMessage: 'Click the  {videoCount, plural, one {button} other {buttons}} below to download.',
        id: 'sessions.summary.download_videos.instructions',
    },
    downloadVideos: {
        defaultMessage: 'Download {videoCount, plural, one {Video} other {Videos}}',
        id: 'sessions.summary.download_videos.title',
    },
    editExternalLink: {
        defaultMessage: 'Edit to create an external link',
        id: 'session.external_link.edit',
    },
    editLink: {
        defaultMessage: 'Edit Link',
        id: 'sessions.people.edit_link.button',
    },
    editPeopleEmpty: {
        defaultMessage: 'Edit to add/remove users',
        id: 'people.edit_empty',
    },
    editScenarioPlaceholder: {
        defaultMessage: 'Edit to select a Scenario',
        id: 'summary_scenario_title.placeholder',
    },
    editSession: {
        defaultMessage: 'Edit Session',
        description: 'Edit Session',
        id: 'sidebar_session_edit.header',
    },
    enterEmailAddress: {
        defaultMessage: 'Enter Email address...',
        id: 'enterEmailAddress_input.placeholder',
    },
    enterNameOrganization: {
        defaultMessage: 'Search for user or organization',
        id: 'enterNameOrganization_input.placeholder',
    },
    evaluationCompleted: {
        defaultMessage: 'Completed',
        id: 'sidebar_evaluations.evaluation_completed',
    },
    evaluationDoesNotExist: {
        defaultMessage: 'Evaluation does not exist',
        id: 'sidebar_evaluations.evaluationDoesNotExist',
    },
    evaluationIncomplete: {
        defaultMessage: 'Incomplete',
        id: 'sidebar_evaluations.evaluation_incomplete',
    },
    evaluations: {
        defaultMessage: 'Evaluations',
        id: 'sidebar_evaluations.label',
    },
    eventLog: {
        defaultMessage: 'Event Log',
        id: 'sidebar_event_log.header',
    },
    eventLogDownloadInstructions: {
        defaultMessage: 'The event log is ready to be exported. Click the button below to download.',
        id: 'sessions.event_log.download.instructions',
    },
    eventLogDownloadTitle: {
        defaultMessage: 'Download Event Log File',
        id: 'sessions.event_log.download.title',
    },
    eventLogExport: {
        defaultMessage: 'Export Event Log',
        id: 'sessions.event_log.export',
    },
    eventLogLoading: {
        defaultMessage: 'Loading events',
        id: 'sidebar_event_log.loading',
    },
    eventLogSearchPlaceholder: {
        defaultMessage: 'Search Event Log',
        id: 'sessions.eventLog.search.placeholder',
    },
    exportTranscript: {
        defaultMessage: 'Export transcript',
        id: 'sessions.exportTranscript',
    },
    externalLink: {
        defaultMessage: 'External Link',
        id: 'session.external_link.label',
    },
    filterContributorSpPlaceholder: {
        defaultMessage: 'Search for Contributor/SP',
        id: 'sessions.filters.contributor_sp.placeholder',
    },
    filterContributorSpTitle: {
        defaultMessage: 'Contributor/SP',
        id: 'sessions.filters.contributor_sp',
    },
    filterContributorsPlaceholder: {
        defaultMessage: 'Search Contributors',
        id: 'sessions.filter.contributors.placeholder',
    },
    filterContributorsTitle: {
        defaultMessage: 'Contributors',
        id: 'sessions.filter.contributors',
    },
    filterCoursePlaceholder: {
        defaultMessage: 'Select a Course',
        id: 'sessions.filters.course.placeholder',
    },
    filterParticipantsPlaceholder: {
        defaultMessage: 'Search Participants',
        id: 'sessions.filters.participants.placeholder',
    },
    filterScenarioPlaceholder: {
        defaultMessage: 'Select a Scenario',
        id: 'sessions.filters.scenario.placeholder',
    },
    filterSupportStaffPlaceholder: {
        defaultMessage: 'Search Support Staff/Faculty',
        id: 'sessions.filters.support_staff.placeholder',
    },
    filteredByCourse: {
        defaultMessage: 'Showing sessions for course "{courseName}". {removeFilterLink}',
        id: 'sessions.list.filtered_by_course',
    },
    filteredByScenario: {
        defaultMessage: 'Showing sessions for scenario "{scenarioName}". {removeFilterLink}',
        id: 'sessions.list.filtered_by_scenario',
    },
    generateTranscript: {
        defaultMessage: 'Generate transcript',
        id: 'sessions.generateTranscript',
    },
    gudridDemoTitle: {
        defaultMessage: 'SimGo',
        id: 'sessions.gudridDemoTitle',
    },
    gudridIaAppOpenMessageTitle: {
        defaultMessage: 'Instructor App opened in {viewMode}',
        id: 'sessions.gudridIaAppOpenMessageTitle',
    },
    gudridIaAppOpenMessageInstruction: {
        defaultMessage: 'Close the {viewMode} to continue viewing SimGo vitals here',
        id: 'sessions.gudridIaAppOpenMessageInstruction',
    },
    gudridShowPatientMonitorLabel: {
        defaultMessage: 'Show Patient Monitor',
        id: 'sessions.gudridShowPatientMonitorLabel',
    },
    gudridHidePatientMonitorLabel: {
        defaultMessage: 'Hide Patient Monitor',
        id: 'sessions.gudridHidePatientMonitorLabel',
    },
    gudridSplitScreenText: {
        defaultMessage: 'split screen',
        id: 'sessions.gudridSplitScreenText',
    },
    gudridPopoutText: {
        defaultMessage: 'popout',
        id: 'sessions.gudridPopoutText',
    },
    gudridIaAppOpenMessageFocusButton: {
        defaultMessage: 'Focus {viewMode}',
        id: 'sessions.gudridIaAppOpenMessageFocusButton',
    },
    gudridIaAppOpenMessageCloseButton: {
        defaultMessage: 'Close {viewMode}',
        id: 'sessions.gudridIaAppOpenMessageCloseButton',
    },
    gudridIaLockControlledByUser: {
        defaultMessage: 'Controlled by {userName}',
        id: 'sessions.gudridIaLockControlledByUser',
    },
    gudridIaLockControlledByYou: {
        defaultMessage: 'You are controlling the Instructor App',
        id: 'sessions.gudridIaLockControlledByYou',
    },
    gudridIaLockOtherUser: {
        defaultMessage: 'another user',
        id: 'sessions.gudridIaLockOtherUser',
    },
    hideEventLogFilters: {
        defaultMessage: 'Hide event log filters',
        id: 'sessions.event_log.filters.hide',
    },
    hideSidebar: {
        defaultMessage: 'Hide Sidebar',
        description: 'Edit Session',
        id: 'sidebar.hide',
    },
    importCourseSenarioHelpText: {
        defaultMessage: 'What Course & Scenario is this session included in?',
        id: 'sessions.import.course_scenario.help_text',
    },
    importDefaultSessionTitle: {
        defaultMessage: 'Session - {date}',
        id: 'sessions.import.title.default',
    },
    importDisallowedModalTitle: {
        defaultMessage: 'Unsupported {count, plural, one {Format} other {Formats}}',
        id: 'sessions.import.modal.disallowed.title',
    },
    importExcessModalTitle: {
        defaultMessage: 'You are attempting to upload too many files',
        id: 'sessions.import.modal.excess.title',
    },
    importFailedToUploadVideos: {
        defaultMessage: 'Failed to Upload',
        id: 'sessions.import.uploaded_videos.failed',
    },
    importHelp: {
        defaultMessage: 'To import a session from an external device, select the file from your device.',
        id: 'sessions.import.help',
    },
    importLocationHelpText: {
        defaultMessage: 'Where is this session being recorded?',
        id: 'sessions.import.location.help_text',
    },
    importNoVideosModalTitle: {
        defaultMessage: 'No videos selected',
        id: 'sessions.import.modal.no_videos.title',
    },
    importNotesHelpText: {
        defaultMessage: 'Does this session require additional information?',
        id: 'sessions.import.notes.help_text',
    },
    importOrganizationHelpText: {
        defaultMessage: 'What organization is using this session?',
        id: 'sessions.import.organization.help_text',
    },
    importOverlay: {
        defaultMessage: 'Uploading sessions coming soon',
        id: 'sessions.import.importOverlay',
    },
    importScenarioHelpText: {
        defaultMessage: 'What Scenario is this session using?',
        id: 'sessions.import.scenario.help_text',
    },
    importSessionStartTsHelpText: {
        defaultMessage: 'When does this session start?',
        id: 'sessions.import.startts.help_text',
    },
    importTitleHelpText: {
        defaultMessage: 'What is the title of this session?',
        id: 'sessions.import.title.help_text',
    },
    importUpload: {
        defaultMessage: 'Upload Videos',
        id: 'sessions.import.upload',
    },
    importUploadedVideos: {
        defaultMessage: 'Uploaded Videos',
        id: 'sessions.import.uploaded_videos',
    },
    importWarningAllFilesDisallowed: {
        defaultMessage: 'None of your selected files can be uploaded.',
        id: 'sessions.import.modal.disallowed.warning.all_files',
    },
    importWarningAllowedFiles: {
        defaultMessage: '{count, plural, one {This file} other {These files}} can be uploaded.',
        id: 'sessions.import.modal.disallowed.warning.allowed_files',
    },
    importWarningMaxReached: {
        defaultMessage: 'You have reached the {count} video maximum.',
        id: 'sessions.import.modal.excess.warning.max_reached',
    },
    importWarningMaxReachedInstructions: {
        defaultMessage: 'Remove some uploaded videos if you want to import other videos.',
        id: 'sessions.import.modal.excess.warning.max_reached.instructions',
    },
    importWarningNoVideos: {
        defaultMessage: 'Please upload videos in order to import a session.',
        id: 'sessions.import.modal.no_videos.warning',
    },
    importWarningOneOfSomeFilesDisallowed: {
        defaultMessage: 'One of your selected files cannot be uploaded.',
        id: 'sessions.import.modal.disallowed.warning.one_of_some_files',
    },
    importWarningOnlyDisallowed: {
        defaultMessage: 'The file you have selected cannot be uploaded.',
        id: 'sessions.import.modal.disallowed.warning.only_file',
    },
    importWarningOverflow: {
        defaultMessage: 'Adding these files to your uploaded videos will exceed the {count} video maximum.',
        id: 'sessions.import.modal.excess.warning.overflow',
    },
    importWarningOverflowInstructions: {
        defaultMessage: 'Remove some uploaded videos or make a new selection.',
        id: 'sessions.import.modal.excess.warning.overflow.instructions',
    },
    importWarningSomeFilesDisallowed: {
        defaultMessage: '{number} of your selected files cannot be uploaded.',
        id: 'sessions.import.modal.disallowed.warning.some_files',
    },
    importWarningTooLarge: {
        defaultMessage: 'The number of files you have selected exceeds the {count} video maximum.',
        id: 'sessions.import.modal.excess.warning.too_large',
    },
    importWarningTooLargeInstructions: {
        defaultMessage: 'Please make another selection with no more than {count} videos.',
        id: 'sessions.import.modal.excess.warning.too_large.instructions',
    },
    inProgressEvaluationTitle: {
        defaultMessage: '{evaluator} started {evaluatee} Evaluation',
        id: 'sidebar_evaluations.in_progress_title',
    },
    inProgressEvaluationTitleTeam: {
        defaultMessage: '{evaluator} started Team Evaluation',
        id: 'sidebar_evaluations.in_progress_title_team',
    },
    inProgressReflectionTitle: {
        defaultMessage: '{evaluator} Reflection',
        id: 'sidebar_evaluations.in_progress_reflection_title',
    },
    instructorAppPopOutDisabledTooltip: {
        defaultMessage: 'Please select a patient monitor',
        id: 'sidebar_gudrid.popout_disabled_tooltip',
    },
    instructorAppPopOutFocusTooltip: {
        defaultMessage: 'Focus Instructor App',
        id: 'sidebar_gudrid.popout_focus_tooltip',
    },
    instructorAppPopOutTooltip: {
        defaultMessage: 'Open Instructor App in new window',
        id: 'sidebar_gudrid.popout_tooltip',
    },
    instructorAppSplitScreenTooltip: {
        defaultMessage: 'Open Instructor App in split screen',
        id: 'sidebar_gudrid.split_screen_tooltip',
    },
    invitePeople: {
        defaultMessage: 'Invite People',
        id: 'invitePeople.label',
    },
    levelOfDetail: {
        defaultMessage: 'Level of Detail',
        description: 'priority filtering for event log',
        id: 'sessions.event_log.filters.level_of_detail',
    },
    linkToSession: {
        defaultMessage: 'Link to this Session',
        id: 'session.link_to',
    },
    liveVideoNotSupported: {
        defaultMessage: 'Live video is not supported on this device.',
        id: 'sessions.session.live_video_not_supported',
    },
    localNetworkAccessDeniedToast: {
        defaultMessage:
            'Local network access was blocked and might degrade or interrupt live video. Please update your browser settings or contact your IT team. <link>Learn more</link>',
        id: 'sessions.localNetworkAccessDeniedToast',
    },
    localNetworkAccessPromptModalContents: {
        defaultMessage:
            "Click Allow in the dialog below your browser's address bar to enable local network access for live video streaming.",
        id: 'sessions.localNetworkAccessPromptModalContents',
    },
    localNetworkAccessPromptToast: {
        defaultMessage:
            "Click Allow in the dialog below your browser's address bar to enable local network access for live video streaming.",
        id: 'sessions.localNetworkAccessPromptToast',
    },
    locationError: {
        defaultMessage: 'Please select a valid location.',
        id: 'location_input.error',
    },
    locationPlaceholder: {
        defaultMessage: 'Select Location',
        id: 'location_input.placeholder',
    },
    noAnnotationAvailable: {
        defaultMessage:
            'The annotation library has no predefined annotations. To add annotations, create an ad-hoc annotation above.',
        id: 'sessions.annotations.noAnnotationAvailable',
    },
    noCompletedReflections: {
        defaultMessage: 'No Reflections have been completed yet.',
        id: 'sidebar_evaluations.no_completed_reflections',
    },
    noData: {
        defaultMessage: 'No Data',
        id: 'session.no_data',
    },
    noEvaluation: {
        defaultMessage:
            'This session does not require any evaluations. To add one, associate this session with a scenario that includes an evaluation.',
        id: 'session.noEvaluation',
    },
    noEvaluations: {
        defaultMessage: 'There are no evaluations',
        description: 'There are no evaluations',
        id: 'sidebar_evaluations.no_evaluations',
    },
    noEvaluationsOrReflections: {
        defaultMessage: 'There are no evaluations or reflections',
        description: 'There are no evaluations or reflections',
        id: 'sidebar_evaluations.no_evaluations_or_reflections',
    },
    noEventLogAnnotations: {
        defaultMessage: 'No events have been recorded for this session',
        id: 'sidebar_event_log.no_annotations',
    },
    noEventsFound: {
        defaultMessage: 'No events found',
        id: 'sessions.eventLog.noItemsFound',
    },
    noItemsFound: {
        defaultMessage: 'No {itemType}s found',
        description: 'The search did not find any matching items.',
        id: 'sessions.summary.no_items_found',
    },
    noRecordingsForSessionPhase: {
        defaultMessage: 'This session phase has no recordings',
        id: 'sessions.viewer.noRecordingsForPhase',
    },
    noReflections: {
        defaultMessage: 'There are no reflections',
        description: 'There are no reflections',
        id: 'sidebar_evaluations.no_reflections',
    },
    noReservations: {
        defaultMessage: 'No reservations to select from',
        id: 'sessions.reservations.no_reservations',
    },
    noResults: {
        defaultMessage: '"{text}" was not found.',
        id: 'sessions.annotations.noResults',
    },
    noScenarioAnnotationAvailable: {
        defaultMessage:
            "This session's scenario has no associated predefined annotations. To add annotations, create an ad-hoc annotation above.",
        id: 'sessions.annotations.noScenarioAnnotationAvailable',
    },
    noScenarioPlaceholder: {
        defaultMessage: 'No Scenario',
        id: 'summary_scenario_title.placeholder.none',
    },
    noSearchEntered: {
        defaultMessage: 'Type 3 or more characters to start searching',
        description: 'The user has not typed enough text (3 characters) to trigger a search.',
        id: 'sessions.people.no_search_entered',
    },
    noUsersFound: {
        defaultMessage: 'No users found',
        description: 'The search did not find any matching users.',
        id: 'sessions.people.no_users_found',
    },
    noVideosRecorded: {
        defaultMessage: 'This session has no recordings.',
        id: 'sessions.session.no_videos_recorded',
    },
    organizationError: {
        defaultMessage: 'Please select a valid organization',
        id: 'organization_input.error',
    },
    organizationPlaceholder: {
        defaultMessage: 'Search for an organization',
        id: 'organization_input.placeholder',
    },
    ownerPlaceHolder: {
        defaultMessage: 'Select Owner',
        id: 'owner_input.placeholder',
    },
    participantEvaluation: {
        defaultMessage: 'Participant Evaluation',
        id: 'sidebar_evaluations.participant',
    },
    participantPlaceholder: {
        defaultMessage: 'Search for a participant',
        id: 'participant_input.placeholder',
    },
    participantsPermissions: {
        defaultMessage: 'Participant Permissions',
        id: 'sessions.people.participants_permissions',
    },
    participantsPermissionsInfoText: {
        defaultMessage:
            "Participants can only view video and complete reflections by default. If given permissions they may also create annotations and view other user's annotations",
        id: 'sessions.people.participants_permissions.info_text',
    },
    participantsSearchNoResults: {
        defaultMessage: 'No users available',
        id: 'sessions.participants.no_results',
    },
    patientMonitorLabel: {
        defaultMessage: 'Patient Monitor',
        id: 'patient_monitor_input.label',
    },
    patientMonitorPlaceholder: {
        defaultMessage: 'Search for patient monitor',
        id: 'patient_monitor_input.placeholder',
    },
    patientPermissions: {
        defaultMessage: 'Patient Permissions',
        id: 'sessions.people.patient_permissions',
    },
    patientPermissionsInfoText: {
        defaultMessage: 'Grant additional permissions to the standardized patient.',
        id: 'sessions.people.patient_permissions.info_text',
    },
    pendingEvaluations: {
        defaultMessage: 'Pending Evaluations',
        id: 'sidebar_evaluations.pending',
    },
    permissionSessionAnnotate: {
        defaultMessage: 'Annotate Session',
        id: 'sessions.people.permissions.recording_annotations.annotate',
    },
    permissionSessionEdit: {
        defaultMessage: 'Edit Session',
        id: 'sessions.people.permissions.edit',
    },
    permissionSessionParticipantAnnotate: {
        defaultMessage: 'Annotate Session',
        id: 'sessions.people.permissions.recording_annotations.participant.annotate',
    },
    permissionSessionParticipantRecordingAnnotations: {
        defaultMessage: "View Others' Annotations",
        id: 'sessions.people.permissions.recording_annotations.participant.view_all',
    },
    permissionSessionRecordingAnnotations: {
        defaultMessage: 'View All Annotations',
        id: 'sessions.people.permissions.recording_annotations.view_all',
    },
    permissionSession_Contributor_Results_View: {
        defaultMessage: 'View Results',
        id: 'sessions.people.permissions.results.view',
    },
    permissionSession_Patient_Annotate: {
        defaultMessage: 'Annotate Session',
        id: 'sessions.people.permissions.patient.annotate',
    },
    permissionSession_Patient_View_All_Annotations: {
        defaultMessage: 'View All Annotations',
        id: 'sessions.people.permissions.patient.view_all_annotations',
    },
    permissionSession_Patient_View_Session: {
        defaultMessage: 'View Session',
        id: 'sessions.people.permissions.patient.view_session',
    },
    permissionSessionsView: {
        defaultMessage: 'View Session Video',
        id: 'sessions.people.permissions.view',
    },
    permissionSessions_Contributor_Evaluation_Create: {
        defaultMessage: 'Take Evaluations',
        id: 'sessions.people.permissions.evaluations.create',
    },
    permissionsNeeded: {
        defaultMessage: 'Permissions needed',
        id: 'sessions.permissionsNeeded',
    },
    preventBulkDeleteModalHideSessions: {
        defaultMessage: 'Hide excluded sessions',
        id: 'sessions.prevent_bulk_delete_modal_hide_sessions',
    },
    preventBulkDeleteModalSessions: {
        defaultMessage:
            '{sessionsWithPreventDeleteCount} out of {totalSessionsCount} selected sessions have Prevent Deletion turned on. They will be excluded from bulk deletion.',
        id: 'sessions.prevent_bulk_delete_modal_sessions',
    },
    preventBulkDeleteModalShowSessions: {
        defaultMessage: 'Show excluded sessions',
        id: 'sessions.prevent_bulk_delete_modal_show_sessions',
    },
    preventBulkDeleteModalTitle: {
        defaultMessage: 'One or more sessions cannot be deleted',
        id: 'sessions.prevent_bulk_delete_modal_title',
    },
    preventDeletionSelected: {
        defaultMessage: 'This session has "Prevent Deletion" selected',
        id: 'sessions.prevent_deletion_selected',
    },
    preventDeletionText: {
        defaultMessage: 'PREVENT DELETION',
        id: 'sessions.prevent_deletion_text',
    },
    preventDeletionToggleOff: {
        defaultMessage: 'Off',
        id: 'sessions.prevent_deletion_toggle_off',
    },
    preventDeletionToggleOffMessage: {
        defaultMessage:
            'You are about to turn off Prevent Automatic Deletion. This will allow the session video to be deleted by Scenario and Global Settings. Are you sure you want to Continue?',
        id: 'sessions.prevent_deletion_toggle_off_message',
    },
    preventDeletionToggleOn: {
        defaultMessage: 'On',
        id: 'sessions.prevent_deletion_toggle_on',
    },
    preventDeletionToggleText: {
        defaultMessage:
            'When Prevent Deletion is turned ON, this session video cannot be removed by both automatic and manual deletion.',
        id: 'sessions.prevent_deletion_toggle_text',
    },
    problemLoadingLiveFeeds: {
        defaultMessage: `It's taking longer than usual to load live video. Retrying...`,
        id: 'sessions.live.problem_loading_feeds',
    },
    quickAddContributors: {
        defaultMessage: 'Session contributors ( {count} )',
        id: 'sessions.people.edit.quickAddContributors',
    },
    quickAddParticipants: {
        defaultMessage: 'Session participants ( {count} )',
        id: 'sessions.people.edit.quickAddParticipants',
    },
    quickAddViewers: {
        defaultMessage: 'Session viewers ( {count} )',
        id: 'sessions.people.edit.quickAddViewers',
    },
    recordingHasNoAudioTracks: {
        defaultMessage: 'This recording was not transcribed because it contains no audio tracks.',
        id: 'sessions.recordingHasNoAudioTracks',
    },
    recordingHasNotBeenTranscribed: {
        defaultMessage: 'This recording has not been transcribed.',
        id: 'sessions.recordingHasNotBeenTranscribed',
    },
    recordingTranscriptFileName: {
        defaultMessage: 'Recording transcript {recordingId}',
        id: 'sessions.recordingTranscriptFileName',
    },
    reflectionCompleted: {
        defaultMessage: 'Completed Reflections',
        id: 'sidebar_evaluations.reflection_completed',
    },
    reflectionIncomplete: {
        defaultMessage: 'Incomplete Reflections',
        id: 'sidebar_evaluations.reflection_incomplete',
    },
    reflections: {
        defaultMessage: 'Reflections',
        id: 'sidebar_reflections.label',
    },
    restartCaptureInputs: {
        defaultMessage: 'Restart capture inputs',
        id: 'sessions.viewer.viewer_inputs.restart_capture_inputs',
    },
    restartCaptureInputsModalTitle: {
        defaultMessage: 'Restarting Recording Service',
        id: 'sessions.viewer.viewer_inputs.restart_capture_inputs_modal_title',
    },
    restartCaptureInputsModalMessage: {
        defaultMessage: 'Restarting the Recording Service and fetching updated feeds. This may take 10-20 seconds',
        id: 'sessions.viewer.viewer_inputs.restart_capture_inputs_modal_message',
    },
    removeFilterLink: {
        defaultMessage: 'Remove filter',
        id: 'sessions.list.remove_filter_link',
    },
    reservationError: {
        defaultMessage: 'Select a valid reservation',
        id: 'reservation_input.error',
    },
    reservationPlaceholder: {
        defaultMessage: 'Select Reservation',
        id: 'reservation_input.placeholder',
    },
    reservations: {
        defaultMessage: 'Reservations',
        id: 'sessions.live.reservations',
    },
    restrictedHelpText: {
        defaultMessage: 'You do not have permission to view this tab.',
        id: 'sidebar_restricted.help_text',
    },
    restrictedView: {
        defaultMessage: 'Restricted View',
        description: 'Restricted View',
        id: 'sidebar_restricted.header',
    },
    returnToList: {
        defaultMessage: 'Return to Sessions List',
        id: 'session.return_to_list',
    },
    returnToSummary: {
        defaultMessage: 'Return to Summary',
        description: 'return link from viewer activity',
        id: 'sessions.activity.return_to_summary',
    },
    revalidateSimulator: {
        defaultMessage: 'Re-validate simulator',
        id: 'sessions.new.simulator.revalidate',
    },
    reviewEvaluations: {
        defaultMessage: 'Review completed Evaluations',
        id: 'sidebar_evaluations.review',
    },
    reviewOwnEvals: {
        defaultMessage: 'Review my completed Evaluation',
        id: 'sidebar_evaluations.review.self',
    },
    rolePlaceholder: {
        defaultMessage: 'Search for role',
        id: 'role_input.placeholder',
    },
    samaritanContentReviewWarning: {
        defaultMessage: 'Content generated by Samaritan. Please review for accuracy.',
        id: 'sessions.samaritanContentReviewWarning',
    },
    samaritanGeneratingTranscript: {
        defaultMessage: 'Samaritan is generating a transcript for this recording...',
        id: 'sessions.samaritanGeneratingTranscript',
    },
    scenarioError: {
        defaultMessage: 'Please select a valid scenario.',
        id: 'scenario_input.error',
    },
    scenarioOwnerContributor: {
        defaultMessage: 'Scenario Owner and Contributors',
        description: 'label for scenario owner field',
        id: 'sessions.people.scenario_owner_contributor',
    },
    scenarioOwnerContributorHelp: {
        defaultMessage:
            'Scenario Owner and Contributors are inherited from the selected scenario owner, contributors (with Start, Join, and Edit Scenario Sessions) and cannot be changed. They can view, edit, and annotate sessions but cannot delete the session or change the session owner.',
        description: 'help text to say why the contributor cannot be changed',
        id: 'sessions.people.scenario_owner_contributor_help',
    },
    scenarioPlaceholder: {
        defaultMessage: 'Select Scenario',
        id: 'scenario_input.placeholder',
    },
    scenarioRequiredError: {
        defaultMessage: 'A scenario must be selected if a course is selected.',
        id: 'sessions.scenarioRequiredError',
    },
    searchPlaceholder: {
        defaultMessage: 'Search session titles',
        id: 'sessions.search.placeholder',
    },
    searching: {
        defaultMessage: 'Searching...',
        description: 'A search is in progress.',
        id: 'sessions.people.searching',
    },
    seeCompletedEvaluation: {
        defaultMessage: 'See Completed Evaluation',
        id: 'sidebar_evaluations.completed',
    },
    selectEvaluation: {
        defaultMessage: 'Select an Evaluation',
        id: 'sidebar_evaluations.selectEval',
    },
    sessionChangePeopleConfirm: {
        defaultMessage:
            'Removing users with associated evaluations from this session will result in the deletion of those evaluations.',
        id: 'sessions.sessionChangePeopleConfirm',
    },
    sessionChangePeopleConfirmTitle: {
        defaultMessage: 'Confirm People Changes',
        id: 'sessions.sessionChangePeopleConfirmTitle',
    },
    sessionChangeScenarioConfirm: {
        defaultMessage:
            'This Session is associated with completed Reflections. Changing the Scenario will delete these Reflections irreversibly. Are you sure you want to proceed?',
        id: 'sessions.modal.change_scenario.confirm.message',
    },
    sessionChangeScenarioConfirmTitle: {
        defaultMessage: 'CONFIRM CHANGE SCENARIO',
        id: 'sessions.modal.change_scenario.confirm.title',
    },
    sessionChangeScenarioWarning: {
        defaultMessage:
            'This session has associated completed Reflections. Changing the Scenario will delete these Reflections irreversibly. Are you sure you want to proceed?',
        id: 'sessions.modal.change_scenario.warning.message',
    },
    sessionChangeScenarioWarningTitle: {
        defaultMessage: 'WARNING',
        id: 'sessions.modal.change_scenario.warning.title',
    },
    sessionHasNoAudioCannotTranscribe: {
        defaultMessage: 'This session cannot be transcribed because it contains no audio tracks.',
        id: 'sessions.sessionHasNoAudioCannotTranscribe',
    },
    sessionRecordingExceedsMaximumLength: {
        defaultMessage: 'Recordings longer than 4 hours cannot be transcribed.',
        id: 'sessions.sessionRecordingExceedsMaximumLength',
    },
    sessionImportFailedModal: {
        defaultMessage:
            'There was an issue importing your session video. If this issue persists, please contact support',
        id: 'sessions.session_import_failed_modal.title',
    },
    sessionOwner: {
        defaultMessage: 'Session Owner',
        description: 'label for session owner field',
        id: 'sessions.people.session_owner',
    },
    sessionSettings: {
        defaultMessage: 'Session Settings',
        id: 'sidebar_sessionSettings.label',
    },
    sessionTranscript: {
        defaultMessage: 'Session transcript',
        id: 'sessions.sessionTranscript',
    },
    sharedWith: {
        defaultMessage: 'Shared with',
        id: 'sharedWith.label',
    },
    showAllReservations: {
        defaultMessage: 'Show all Locations',
        id: 'sessions.live.start.all_reservations',
    },
    showEventLogFilters: {
        defaultMessage: 'Show event log filters',
        id: 'sessions.event_log.filters.show',
    },
    showOnlyRecordingAnnotations: {
        defaultMessage: 'Show recording annotations',
        id: 'sessions.event_log.filters.show_only_recording_annotations',
    },
    showOnlySimulatorEvents: {
        defaultMessage: 'Show simulator events',
        id: 'sessions.event_log.filters.show_only_simulator_events',
    },
    showOnlyGudridEvents: {
        defaultMessage: 'Show SimGo events',
        id: 'sessions.event_log.filters.show_only_gudrid_events',
    },
    showSidebar: {
        defaultMessage: 'View Sidebar',
        description: 'Edit Session',
        id: 'sidebar.show',
    },
    simulatorError: {
        defaultMessage: 'Please select a valid Simulator.',
        id: 'simulator_input.error',
    },
    simulatorPlaceholder: {
        defaultMessage: 'Select Simulator',
        id: 'simulator_input.placeholder',
    },
    startFromReservation: {
        defaultMessage: 'Start a Session From a Reservation',
        id: 'sessions.live.start.from_reservation',
    },
    startRecording: {
        defaultMessage: 'Start',
        id: 'start_record_button.label',
    },
    startSessionAdHoc: {
        defaultMessage: 'Start Ad-hoc Session',
        id: 'sessions.live.start.adhoc',
    },
    startSessionReservation: {
        defaultMessage: 'Start Scheduled Session',
        id: 'sessions.live.start.reservation',
    },
    stillUploading: {
        defaultMessage: 'The video is currently being uploaded and should be available shortly.',
        id: 'sessions.viewer.messages.stillUploading',
    },
    stopSessionModalConfirmation: {
        defaultMessage: 'Are you sure you want to end this live session for everyone?',
        id: 'sessions.stop_session_modal.confirmation',
    },
    stopSessionModalTitle: {
        defaultMessage: 'End Session',
        id: 'sessions.stop_session_modal.title',
    },
    streamIndicatorWebrtc: {
        defaultMessage: 'This session is being streamed using CaptureNode WebRTC',
        id: 'sessions.stream_indicator.webrtc',
    },
    streamIndicatorDirectStream: {
        defaultMessage: 'This session is being streamed directly from the CaptureNode over a WebSocket connection',
        id: 'sessions.stream_indicator.direct_stream',
    },
    streamIndicatorDirectStreamWebrtc: {
        defaultMessage:
            'This session is being streamed directly from the CaptureNode via WebRTC. This streaming type is the most stable and lowest latency.',
        id: 'sessions.stream_indicator.direct_stream_webrtc',
    },
    streamIndicatorRemoteDirectStreamWebrtc: {
        defaultMessage: 'This session is being streamed over the internet using relayed WebRTC',
        id: 'sessions.stream_indicator.remote_direct_stream_webrtc',
    },
    streamIndicatorRemoteDirectStreamMse: {
        defaultMessage:
            'This session is being streamed over the internet using a WebSocket connection. You may experience some latency or buffering.',
        id: 'sessions.stream_indicator.remote_direct_stream_mse',
    },
    submitEvaluationConfirmationAllAnswered: {
        defaultMessage: 'Are you sure you want to submit this evaluation?',
        id: 'sidebar_evaluations.submit_confirmation.all_answered',
    },
    submitEvaluationConfirmationSomeUnanswered: {
        defaultMessage: 'Are you sure you want to submit this evaluation? Not all questions have been answered.',
        id: 'sidebar_evaluations.submit_confirmation.some_unanswered',
    },
    submitEvaluationConfirmationTitle: {
        defaultMessage: 'Submit Evaluation',
        id: 'sidebar_evaluations.submit_confirmation.title',
    },
    submitReflectionConfirmationAllAnswered: {
        defaultMessage: 'Are you sure you want to submit this reflection?',
        id: 'sidebar_reflection.submit_confirmation.all_answered',
    },
    submitReflectionConfirmationSomeUnanswered: {
        defaultMessage: 'Are you sure you want to submit this reflection? Not all questions have been answered.',
        id: 'sidebar_reflection.submit_confirmation.some_unanswered',
    },
    submitReflectionConfirmationTitle: {
        defaultMessage: 'Submit Reflection',
        id: 'sidebar_reflection.submit_confirmation.title',
    },
    summary: {
        defaultMessage: 'Summary',
        description: 'Summary',
        id: 'sidebar_summary.header',
    },
    takeEvaluation: {
        defaultMessage: 'Complete Evaluation',
        id: 'sidebar_evaluations.take',
    },
    takeReflection: {
        defaultMessage: 'Complete Reflection',
        id: 'sidebar_reflections.take',
    },
    teamEvaluation: {
        defaultMessage: 'Team Evaluation',
        id: 'sidebar_evaluations.team',
    },
    titleAnnotations: {
        defaultMessage: '{data} - Annotations',
        description: '/:id/annotations',
        id: 'sessions.title.annotations',
    },
    titleBulkUpdate: {
        defaultMessage: 'Bulk Update Sessions',
        description: '/bulk-update',
        id: 'sessions.title.bulk_update',
    },
    titleDebrief: {
        defaultMessage: '{data}',
        description: '/:id',
        id: 'sessions.title.debrief',
    },
    titleEncounter: {
        defaultMessage: 'Encounter',
        id: 'sessions.title.encounter',
    },
    titleEvaluations: {
        defaultMessage: '{data} - Evaluations',
        description: '/:id/evaluations',
        id: 'sessions.title.evaluations',
    },
    titleEvaluationsReview: {
        defaultMessage: '{data} - Evaluations',
        description: '/:id/evaluations/:evaluationId/completed',
        id: 'sessions.title.evaluations_review',
    },
    titleEvaluationsTake: {
        defaultMessage: '{data} - Evaluations',
        description: '/:id/evaluations/:evaluationTemplateId',
        id: 'sessions.title.evaluations_take',
    },
    titleEventLog: {
        defaultMessage: '{data} - Event Log',
        description: '/:id/summary/event-log',
        id: 'sessions.title.event_log',
    },
    titleFollowUp: {
        defaultMessage: 'Follow-Up {number}',
        id: 'sessions.title.follow_up',
    },
    titleImport: {
        defaultMessage: 'Import Session',
        description: '/import',
        id: 'sessions.title.import',
    },
    titleLive: {
        defaultMessage: '{data}',
        description: '/live/:id',
        id: 'sessions.title.live',
    },
    titlePeople: {
        defaultMessage: '{data} - People',
        description: '/:id/people',
        id: 'sessions.title.people',
    },
    titlePeopleEdit: {
        defaultMessage: '{data} - Edit People',
        description: '/:id/people.edit',
        id: 'sessions.title.people.edit',
    },
    titleReflections: {
        defaultMessage: '{data} - Reflections',
        description: '/:id/reflections',
        id: 'sessions.title.reflections',
    },
    titleSelectInputs: {
        defaultMessage: 'Select inputs for session',
        id: 'sessions.title.start_session.select',
    },
    titleSelectInputsWithSessionName: {
        defaultMessage: 'Select inputs for {title}',
        id: 'sessions.title.start_session.select.session_name',
    },
    titleStart: {
        defaultMessage: 'Start Recording',
        description: '/live',
        id: 'sessions.title.start',
    },
    titleStartPlaceholder: {
        defaultMessage: 'Start Recording',
        description: '/live',
        id: 'sessions.title.start.placeholder',
    },
    titleSummary: {
        defaultMessage: '{data} - Summary',
        description: '/:id/summary',
        id: 'sessions.title.summary',
    },
    titleSummaryActivity: {
        defaultMessage: '{data} - Recent Activity',
        description: '/:id/summary/activity',
        id: 'sessions.title.summary.activity',
    },
    titleSummaryEdit: {
        defaultMessage: '{data} - Edit Summary',
        description: '/:id/summary/edit',
        id: 'sessions.title.summary.edit',
    },
    transcriptSearchNoResults: {
        defaultMessage: 'No results found',
        id: 'sessions.transcriptSearchNoResults',
    },
    transcriptSearchPlaceholder: {
        defaultMessage: 'Search transcript',
        id: 'sessions.transcriptSearchPlaceholder',
    },
    transcriptNonRetryableErrorOccurred: {
        defaultMessage: 'An error occurred while generating a transcript for this recording.',
        id: 'sessions.transcriptNonRetryableErrorOccurred',
    },
    transcriptNumberedSpeakerLabel: {
        defaultMessage: 'Person {speakerNumber}',
        id: 'sessions.transcriptNumberedSpeakerLabel',
    },
    transcriptRetryableErrorOccurred: {
        defaultMessage: 'An error occurred while generating a transcript for this recording.',
        id: 'sessions.transcriptNonRetryableErrorOccurred',
    },
    transcriptRetryableErrorTryAgain: {
        defaultMessage: 'Try again',
        id: 'sessions.trancriptNonRetryableErrorTryAgain',
    },
    transcriptionInProgress: {
        defaultMessage: 'Transcription is already in progress. Please refresh the page to check the status.',
        id: 'sessions.transcriptionInProgress',
    },
    transcriptUnavailableWhileUploadingInProgress: {
        defaultMessage: 'Transcript cannot be generated while videos are being processed.',
        id: 'sessions.transcriptUnavailableWhileUploadingInProgress',
    },
    transcriptionUnavailableWhileTrimmingInProgress: {
        defaultMessage: 'This session cannot be transcribed right now because it is currently being trimmed.',
        id: 'sessions.transcriptionUnavailableWhileTrimmingInProgress',
    },
    trimmingInProgress: {
        defaultMessage: 'The video is currently being trimmed and should be available shortly.',
        id: 'sessions.viewer.messages.trimming_in_progress',
    },
    unAvailableInputs: {
        defaultMessage: '{data} offline inputs',
        id: 'sessions.inputs.unavailable',
    },
    updateOffsetError: {
        defaultMessage: 'Cannot Update offset to the future.',
        id: 'sessions.viewer.eventlog.offset.error',
    },
    updatePermissionsHelp: {
        defaultMessage:
            "If course-level users or their permissions have been updated, you can update this session's permissions to match.",
        id: 'sessions.updatePermissionsHelp',
    },
    uploadCAESimFile: {
        defaultMessage:
            'Click the \'Choose Files\' button below to select CAE log files to upload and attach to this session.\n\n CAE log files are typically located in the "/Applications/HPS Version 6/Logs" folder. Each session will have either three log files with a consistent numeric prefix and a named suffix Physio, Drug, and Events, such as 0086-Drug.txt, 0086-Events.txt, and 0086-Physio.txt or two log files with a date then a consistent numeric prefix and a named suffix PhysiologicalDataLog and SimulationEventsLog such as 2011-01-06_1056_SimulationEventsLog.csv , 2011-01-06_1056_PhysiologicalDataLog.csv. All two/three files must be provided in order to attach results.',
        id: 'sessions.uploadCAESimFile',
    },
    uploadGaumardSimFile: {
        defaultMessage:
            'Click the \'Choose File\' button below to select Gaumard session report to upload and attach to this session. If auto save is enabled, the Gaumard session reports are automatically saved in the "/Gaumard User Interface/autosave" folder. Otherwise, user must choose to save the report after running a session, and must remember where it is saved.',
        id: 'sessions.uploadGaumardSimFile',
    },
    uploadLaerdalSimFile: {
        defaultMessage:
            "Click the 'Choose File' button below to select Debrief Viewer File to upload and attach to this session. Debrief Viewer Files have a .sbr or a .sss extension and are saved by the Laerdal Debrief Viewer application. Viewer files are not saved by default and are not placed in any specific location--the user must choose to save the file after running a session and must remember where it is saved.",
        id: 'sessions.uploadLaerdalSimFile',
    },
    uploadOtherSimFile: {
        defaultMessage:
            "Click the 'Choose Files' button below to select the applicable log files to upload and attach to this session. Only certain file types are supported per manufacturer - please check with the simulator manufacturer to confirm integration with SimCapture.",
        id: 'sessions.uploadOtherSimFile',
    },
    uploadSimDataFile: {
        defaultMessage: 'Upload Debrief Viewer File',
        id: 'sessions.uploadSimDataFile',
    },
    uploadSimDataFileBadFormat: {
        defaultMessage: 'One or more of the selected files are not the correct format.',
        id: 'sessions.uploadSimDataFileBadFormat',
    },
    uploadSimDataFileError: {
        defaultMessage: 'Failed to upload one or more simulator files.',
        id: 'sessions.uploadSimDataFileError',
    },
    videoNotReadyCheckLater: {
        defaultMessage: 'The video is taking longer than expected to be uploaded. Please check back later.',
        id: 'sessions.viewer.messages.videoNotReadyCheckLater',
    },
    videosDeleted: {
        defaultMessage: 'The recording for this session has been deleted.',
        id: 'sessions.delete_session.videos_deleted',
    },
    viewActivityLink: {
        defaultMessage: 'View Activity',
        id: 'sessions.summary.view_activity_link',
    },
    viewAllEvaluations: {
        defaultMessage: 'View all Evaluations',
        id: 'sidebar_evaluations.viewAll',
    },
    viewCount: {
        defaultMessage: 'Views',
        description: 'number of views',
        id: 'sessions.summary.view_count',
    },
    viewMyEvaluations: {
        defaultMessage: 'View my Evaluations',
        id: 'sidebar_evaluations.viewAll.self',
    },
    viewerActualInventoryItems: {
        defaultMessage: 'Actual Inventory Consumed During Session',
        id: 'sessions.viewer.viewer_actual_inventory_items',
    },
    viewerDescription: {
        defaultMessage:
            'Participants are {styledTextPart1} included in the viewer permission. Go to {styledTextPart2} to provide participant viewing access.',
        id: 'sessions.people.viewer_description',
    },
    viewerDescriptionLink: {
        defaultMessage: 'Release Scores',
        id: 'sessions.people.viewer_description_link',
    },
    viewerDescriptionPro: {
        defaultMessage:
            'Adding an Organization will  also grant viewing permission to all Admins and Participants in this Organization.',
        id: 'sessions.people.viewer_description_pro',
    },
    viewerErrorRecordingDeviceOffline: {
        defaultMessage:
            'The Recording Device associated with this Location is offline. Please try again later, or contact a System Administrator for assistance.',
        id: 'sessions.viewerErrorRecordingDeviceOffline',
    },
    viewerErrorWebRtcIceUnknown: {
        defaultMessage: 'Unable to access TURN Server. Please contact your network team for resolution.',
        id: 'sessions.viewer.webrtc_unknown_error',
    },
    viewerMatchInventoryRequired: {
        defaultMessage: 'Match inventory required',
        id: 'sessions.viewer.match_inventory_required',
    },
    viewerNoInventoryItems: {
        defaultMessage: 'Inventory Required',
        id: 'sessions.viewer.no_inventory_items',
    },
    viewerNoInventoryRequired: {
        defaultMessage: 'No inventory required',
        id: 'sessions.viewer.no_inventory_required',
    },
    viewerNoInventorySpecified: {
        defaultMessage: 'No scenario or reservation specified',
        id: 'sessions.viewer.no_inventory_specified',
    },
    viewerPlaceholder: {
        defaultMessage: 'Search for a viewer',
        id: 'viewer_input.placeholder',
    },
    viewerProvidedInventoryItems: {
        defaultMessage: 'Inventory Required By "{title}"',
        id: 'sessions.viewer.provided_inventory_items',
    },
    viewerReservationInventoryItems: {
        defaultMessage: 'Inventory Required By Reservation',
        id: 'sessions.viewer.reservation_inventory_items',
    },
    viewerScenarioInventoryItems: {
        defaultMessage: 'Inventory Required By Scenario',
        id: 'sessions.viewer.scenario_inventory_items',
    },
    viewersPermissions: {
        defaultMessage: 'Viewer Permissions',
        id: 'sessions.people.viewers_permissions',
    },
    viewersPermissionsInfoText: {
        defaultMessage: 'Internal viewers can only see video, notes, and any simulator data',
        id: 'sessions.people.viewers_permissions.info_text',
    },
    warnDeletingEvals: {
        defaultMessage:
            'WARNING: Deleting the selected sessions will also delete all associated evaluations/reflections irrecoverably.\n\nConsider deleting the session videos only to preserve this data.',
        id: 'session_list.bulk_delete.warn_evals',
    },
    warnDeletingSessionEvals: {
        defaultMessage:
            'WARNING: Deleting this session will also delete all associated evaluations/reflections irrecoverably.\n\nConsider deleting the session videos only to preserve this data.',
        id: 'sessions.delete_session_modal.warn_evals',
    },
    viewerLocationRestricted: {
        defaultMessage:
            'This location is currently unavailable. Please contact your system administrator for assistance.',
        id: 'sessions.viewer.location_restricted',
    },
    viewerLocationInUse: {
        defaultMessage:
            'This location is currently in use by another session. Please contact your system administrator for assistance.',
        id: 'sessions.viewer.location_in_use',
    },
    viewerLocationConfigured: {
        defaultMessage:
            'This location is currently configured and cannot be accessed. Please contact your system administrator for assistance.',
        id: 'sessions.viewer.location_configured',
    },
    viewerCannotJoinSession: {
        defaultMessage:
            'You do not have permission to join this session. Please contact your system administrator for assistance.',
        id: 'sessions.viewer.cannot_join_session',
    },
    weakNetworkConnectivityAlert: {
        defaultMessage:
            'Weak connectivity: Network connectivity is low and may cause disruption or reduced quality in live or debrief video. If possible, move to a stronger network area.',
        id: 'sessions.weak_network_connectivity_alert',
    },
} as const;

export default sessionsMessages;
